/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';
import { ApiDefSpecData } from '../../models/api-def-spec-data';

export interface OrganizationsUpdateSpecVersion$Params {

/**
 * The ID of the organization to update the spec version in
 */
  organizationId: string;

/**
 * The ID of the project to update the spec version in
 */
  projectId: string;

/**
 * The ID of the upload intent to update the spec version for
 */
  uploadIntentId: string;
      body: {

/**
 * The name of the spec version
 */
'versionName'?: string;

/**
 * The status of the spec version
 * Possible values:
 * - `public` - The spec version is public and can be accessed by anyone.
 * - `private` - The spec version is private and can only be accessed by viewers of the organization.
 * - `hidden` - The spec version is hidden and cannot be accessed by anyone.
 */
'status'?: 'public' | 'private' | 'hidden';
}
}

export function organizationsUpdateSpecVersion(http: HttpClient, rootUrl: string, params: OrganizationsUpdateSpecVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateSpecVersion.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.path('uploadIntentId', params.uploadIntentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      'spec'?: ApiDefSpecData;
      }>;
    })
  );
}

organizationsUpdateSpecVersion.PATH = '/organizations/{organizationId}/projects/{projectId}/specs/{uploadIntentId}';
